<app-company-info></app-company-info>
<app-product-list></app-product-list>
<app-contact-list></app-contact-list>
